import type {
  EmailLoginDto,
  LoginDto,
  VerifyEmailSendResponseDto,
} from '@nomiss/sdk';
import {
  ApiRequestError,
  executeSdkRawRequest,
} from './api-request.util';
import type { AuthTokenPair } from './auth-phone.service';
import { authenticationApi, otpApi } from './sdk-client';

export type EmailOtpSendResult = VerifyEmailSendResponseDto;

export type EmailLoginPayload = {
  email: string;
  otp: number;
  phone?: string;
  visitorId?: string;
  deviceFingerprint?: string;
};

export class EmailLoginError extends ApiRequestError {
  constructor(status: number, message: string, errorCode?: string) {
    super(status, message, 'EmailLoginError', errorCode);
  }
}

export async function generateEmailOtp(payload: {
  email: string;
  boundPhone?: string;
}): Promise<EmailOtpSendResult> {
  return executeSdkRawRequest<EmailOtpSendResult>({
    request: () =>
      otpApi.otpControllerGenerateOtpV1Raw({
        generateOtpDto: {
          email: payload.email.trim().toLowerCase(),
          ...(payload.boundPhone ? { boundPhone: payload.boundPhone } : {}),
        },
      }),
    fallback: 'Failed to generate email OTP',
    ErrorClass: EmailLoginError,
  });
}

export async function emailLogin(
  payload: EmailLoginPayload,
): Promise<AuthTokenPair> {
  const dto: EmailLoginDto = {
    email: payload.email.trim().toLowerCase(),
    otp: payload.otp,
    ...(payload.phone ? { phone: payload.phone } : {}),
    ...(payload.visitorId ? { visitorId: payload.visitorId } : {}),
    ...(payload.deviceFingerprint
      ? { deviceFingerprint: payload.deviceFingerprint }
      : {}),
  };

  return executeSdkRawRequest({
    request: () =>
      authenticationApi.authControllerEmailLoginV1Raw({
        emailLoginDto: dto,
      }),
    fallback: 'Email login failed',
    ErrorClass: EmailLoginError,
  });
}

export async function loginWithPassword(dto: LoginDto): Promise<AuthTokenPair> {
  return executeSdkRawRequest({
    request: () =>
      authenticationApi.authControllerLoginV1Raw({
        loginDto: dto,
      }),
    fallback: 'Login failed',
    ErrorClass: ApiRequestError,
  });
}
